export default __webpack_public_path__ + "login-bg-web.png";